<template>
    <div>
        <div class="row">
            <div class="col-md-4">
                <div class="row mb-2">
                    <label class="form-label ml-3 font-weight-700 fs-md color-black">Thông tin lịch test</label>
                </div>
                <div class="card card-custom gutter-b example example-compact border border-gray mb-3">
                    <div class="card-body">
                        <div v-if="loading" class="text-center py-5">
                            <i class="el-icon-loading"></i>
                        </div>
                        <div v-else>
                            <div class="form-row mt-2 mb-3">
                                <div class="col-md-6 mb-3">
                                    <label>Họ và tên khách hàng</label>
                                    <el-input type="text" v-model="exam.user_name" disabled />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>Số điện thoại khách hàng</label>
                                    <el-input type="text" v-model="exam.user_phone" disabled />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>Trung tâm</label>
                                    <el-input type="text" v-model="exam.center_name" disabled />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>Ngày làm</label>
                                    <el-input type="text" :value="formatDate(exam.date)" disabled />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>Thời gian thi</label>
                                    <el-input type="text"
                                        :value="formatTime(exam.start_time) + ' - ' + formatTime(exam.end_time)"
                                        disabled />
                                </div>
                                <div class="col-md-12 mb-3 exam-actions">
                                    <button v-if="showButtonBoQuaBuocTest" type="button" class="btn btn-danger"
                                        @click="openSkipDialog">
                                        <i class="fa fa-ban"></i>
                                        Bỏ qua bước test
                                    </button>
                                    <button v-if="showButtonDatLai" type="button" class="btn btn-success"
                                        @click="openEntranceScheduleDialog(false)">
                                        <i class="fa fa-undo"></i>
                                        Đặt lại
                                    </button>
                                    <button v-if="showButtonDangKyThiLai" type="button"
                                        class="btn btn-success" @click="openEntranceScheduleDialog(true)">
                                        <i class="fa fa-repeat"></i>
                                        Đăng ký thi lại
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-2 mt-6">
                    <label class="form-label ml-3 font-weight-700 fs-md color-black">Hướng dẫn học viên tham gia ca thi</label>
                </div>
                <div class="card card-custom gutter-b example example-compact border border-gray mb-3">
                    <div class="card-body">
                        <div v-if="loading" class="text-center py-5">
                            <i class="el-icon-loading"></i>
                        </div>
                        <div v-else>
                            <h4 class="exam-guide__title">Vào nhóm Zalo hỗ trợ</h4>
                            <p class="exam-guide__desc">
                                Tư vấn viên cần gửi link và đảm bảo học viên vào nhóm zalo hỗ trợ
                            </p>
                            <el-input class="exam-guide__field exam-guide__field--link" :value="exam.link_group_zalo"
                                readonly>
                                <el-tooltip v-if="is_lastest_version" slot="suffix" content="Sao chép link zalo" placement="top">
                                    <i class="el-icon-document-copy exam-guide__copy"
                                        @click="copyText(exam.link_group_zalo)"></i>
                                </el-tooltip>
                            </el-input>
                        </div>
                    </div>
                </div>

                <div class="card card-custom gutter-b example example-compact border border-gray mb-3">
                    <div class="card-body">
                        <div v-if="loading" class="text-center py-5">
                            <i class="el-icon-loading"></i>
                        </div>
                        <div v-else>
                            <h4 class="exam-guide__title">Truy cập web thi</h4>
                            <p class="exam-guide__desc">
                                Quét mã QR hoặc mở link, sau đó nhập mã dự thi để đăng nhập vào phòng thi.
                            </p>
                            <div class="d-flex align-items-start">
                                <div class="exam-guide__qr mr-4">
                                    <qr-code :text="examWebUrl" :size="100" />
                                </div>
                                <div class="flex-grow-1">
                                    <div class="exam-guide__label">LINK WEB THI</div>
                                    <el-input class="exam-guide__field exam-guide__field--link" :value="examWebUrl"
                                        readonly>
                                        <el-tooltip v-if="is_lastest_version" slot="suffix" content="Sao chép link web thi" placement="top">
                                            <i class="el-icon-document-copy exam-guide__copy"
                                                @click="copyText(examWebUrl)"></i>
                                        </el-tooltip>
                                    </el-input>
                                    <div class="exam-guide__label mt-3">MÃ DỰ THI</div>
                                    <el-input class="exam-guide__field" :value="exam.exam_code" readonly>
                                        <el-tooltip v-if="is_lastest_version" slot="suffix" content="Sao chép mã dự thi" placement="top">
                                            <i class="el-icon-document-copy exam-guide__copy"
                                                @click="copyText(exam.exam_code)"></i>
                                        </el-tooltip>
                                    </el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-8">
                <div class="container mt-xl-0">
                    <div class="row">
                        <label class="form-label ml-3 font-weight-700 fs-md color-black">Trạng thái ca test</label>
                    </div>
                    <div class="row ml-12 mb-4">
                        <label class="status-test-input ml-3 pt-2 pr-4 pb-2 pl-4 badge badge-large" :class="statusClass">
                            {{ statusText }}
                        </label>
                    </div>
                    <h3 class="form-label font-weight-700 fs-md color-black">Kết quả bài test</h3>
                    <div class="card" style="background-color: #F6F6F6;">
                        <div class="content_result p-4">
                            <div v-if="loading" class="text-center py-5">
                                <i class="el-icon-loading"></i>
                            </div>
                            <div v-else-if="hasResultContent">
                                <div v-for="result in resultTests" :key="result.key"
                                    class="bg-white rounded-sm px-4 pt-4 pb-2 mb-3 border">
                                    <div class="row">
                                        <div class="col-6 d-flex align-content-center">
                                            <img src="../../../assets/img/loaImg.png" style="height: 25px" alt="">
                                            <h4 class="ml-2 mb-0 mt-1" style="font-size: 16px">{{ result.name }}</h4>
                                        </div>
                                        <div class="col-6 score d-flex flex-row-reverse">
                                            <h4>Số điểm: {{ result.score }} /9.0</h4>
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <h4 v-if="result.key !== 'vocabulary_and_grammar'">Nhận xét:</h4>
                                        <p v-if="result.totalQuestions" class="mb-0">
                                            Học viên đúng {{ result.correctCount }}/{{ result.totalQuestions }} câu
                                            trong kỹ năng này
                                        </p>
                                        <p v-else class="mb-0">
                                            Học viên đọc phần nhận xét chi tiết để hiểu rõ những tiêu chí của kĩ năng
                                            này
                                        </p>
                                        <div class="text-center mt-2" v-if="result.comments.length > 0">
                                            <el-collapse>
                                                <el-collapse-item title="Xem chi tiết" name="1" class="text-[15px]">
                                                    <div v-for="(comment, index) in result.comments" :key="index"
                                                        class="mb-5 text-left text-[15px]">
                                                        <h4 style="font-weight: bold">Tiêu chí {{ index + 1 }}: {{
                                                            comment.name }}</h4>
                                                        <p style="white-space: pre-line">{{ comment.autoComment }}</p>
                                                        <h4 v-if="comment.detail">Chi tiết:</h4>
                                                        <p style="white-space: pre-line">{{ comment.detail }}</p>
                                                        <hr>
                                                    </div>
                                                </el-collapse-item>
                                            </el-collapse>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="hasOverallScore" class="bg-white rounded-sm px-4 pt-4 pb-4 mb-3 border">
                                    <div class="row">
                                        <div class="col-6 d-flex align-content-center">
                                            <img src="../../../assets/img/loaImg.png" style="height: 25px" alt="">
                                            <h4 class="ml-2 mb-0 mt-1" style="font-size: 16px">Overall</h4>
                                        </div>
                                        <div class="col-6 score d-flex flex-row-reverse">
                                            <h4>Số điểm: {{ overallScore }} /9.0</h4>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="exam.recommended_course_name">
                                    <h3>Khóa học gợi ý</h3>
                                    <div class="bg-white rounded-sm p-5 border" style="font-size: 16px">
                                        {{ exam.recommended_course_name }}
                                    </div>
                                </div>

                                <div class="mt-4" v-if="exam.supplementary_course_name">
                                    <h3>Khóa học bổ sung</h3>
                                    <div class="bg-white rounded-sm p-5 border" style="font-size: 16px">
                                        {{ exam.supplementary_course_name }}
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p class="mb-0" style="font-size: 16px">Chưa có kết quả.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <skip-entrance-test-dialog
            :visible.sync="skipDialogVisible"
            :customer-id="customerId || exam.customer_id"
            @skipped="handleSkipped"
        />
        <schedule-entrance-test-dialog
            :visible.sync="scheduleEntranceTestDialogVisible"
            :title="entranceRetakeMode ? 'Đặt lịch thi đầu khóa' : 'Đặt lịch test đầu vào'"
            :retake-center-id="entranceRetakeMode ? exam.center_id : null"
            :close-on-confirm="false"
            :confirm-loading="entranceScheduleConfirmLoading"
            @confirm="confirmEntranceSchedule"
        />
        <el-dialog
            v-if="[STATUS_PENDING, STATUS_FAlURE, STATUS_OVER_LOADING].includes(statusCreateTestInput)"
            title="Đặt lịch test đầu vào"
            class="responsive"
            width="570px"
            :visible.sync="openScheduleTestInput"
            :destroy-on-close="true"
            @close="resetModal"
            :close-on-click-modal="false"
            :show-close="true"
        >
            <el-row :gutter="10" class="pr-2 pl-2">
                <LoadingCreateTestInput v-if="statusCreateTestInput === STATUS_PENDING"
                    :idTaskCreating="idTaskCreating" @statusCreateTestInput="handleStatusCreateTestInput"
                    :countTime="countTime" />
                <cancel-create-input v-if="statusCreateTestInput === STATUS_FAlURE"
                    @closeModal="openScheduleTestInput = false" />
                <overload-create-test-input v-if="statusCreateTestInput === STATUS_OVER_LOADING"
                    @closeModal="openScheduleTestInput = false" />
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment-timezone";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
    GET_RESULT_ENTRANCE_EXAM,
    REGISTER_ENTRANCE_EXAM,
    CHECK_STATUS_ENTRANCE_EXAM
} from "@/core/services/store/customer/entrance.module";
import {
    CREATE_TEST_INPUT_SCHEDULE_CUSTOMER,
    STORE_SPEAKING_API
} from "@/core/services/store/customer/testInput.module";
import { ECOACH } from "@/core/config/center/centerOption";
import {
    Mentor_English_Mastery_ID,
    STATUS_FAlURE,
    STATUS_OVER_LOADING,
    STATUS_PENDING,
    STATUS_TO_DO,
    TYPE_SPEAKING_AI
} from "@/core/config/testInput/testInputOption";
import { buildScheduleBandPayload } from "@/core/config/testInput/scheduleFieldOption";
import ScheduleEntranceTestDialog from "./components/ScheduleEntranceTestDialog.vue";
import SkipEntranceTestDialog from "./components/SkipEntranceTestDialog.vue";
import { STATUS_DA_BO_QUA_KIEM_TRA_LABEL } from "@/core/config/customer/testInputSchedule";
import LoadingCreateTestInput from "./components/LoadingCreateTestInput.vue";
import CancelCreateInput from "./components/CancelCreateInput.vue";
import OverloadCreateTestInput from "./components/OverloadCreateTestInput.vue";

const SKILLS = [
    {key: "vocabulary_and_grammar", name: "Vocabulary and Grammar"},
    { key: "speaking", name: "Speaking" },
    { key: "listening", name: "Listening" },
    { key: "reading", name: "Reading" },
    { key: "writing", name: "Writing" }
];

const STATUS_CHEAT = "Gian lận";
const STATUS_ABSENT = "Vắng thi";
const STATUS_REGISTERED = "Đã đăng ký";
const STATUS_RETURNED_RESULT = "Đã trả kết quả";
// type check-status-entrance-exam: 1 = Đặt lại, 2 = Đăng ký thi lại
const TYPE_CHECK_DAT_LAI = 1;
const TYPE_CHECK_DANG_KY_THI_LAI = 2;
const TYPE_CHECK_BO_QUA = 1;

export default {
    name: "detail-entrance-exam-schedule",
    components: {
        ScheduleEntranceTestDialog,
        SkipEntranceTestDialog,
        LoadingCreateTestInput,
        CancelCreateInput,
        OverloadCreateTestInput
    },
    data() {
        return {
            loading: false,
            exam: {},
            scheduleEntranceTestDialogVisible: false,
            skipDialogVisible: false,
            entranceRetakeMode: false,
            entranceScheduleConfirmLoading: false,
            openScheduleTestInput: false,
            statusCreateTestInput: null,
            idTaskCreating: null,
            createdTestInputScheduleId: null,
            countTime: 60,
            idCustomer: null,
            successCreateData: {},
            STATUS_PENDING,
            STATUS_TO_DO,
            STATUS_FAlURE,
            STATUS_OVER_LOADING
        };
    },
    watch: {
        markingExamRetakeId() {
            this.getEntranceExamResult();
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Danh sách khách hàng", route: "customer-list" },
            { title: "Chi tiết ca thi đầu khóa", icon: "fas fa-book" }
        ]);
        this.getEntranceExamResult();
    },
    computed: {
        markingExamRetakeId() {
            return this.$route.query.marking_exam_retake_id || this.$route.params.marking_exam_retake_id;
        },
        customerId() {
            return this.$route.query.customer_id;
        },
        is_lastest_version() {
            const q = this.$route.query.is_latest;
            if (q === '1' || q === '0') {
                return q === '1';
            }
            // Chưa có flag BE: không có query thì giữ hành vi cũ (cho phép thao tác)
            return true;
        },
        showButtonDatLai() {
            return this.is_lastest_version
                && [STATUS_REGISTERED].includes(this.exam.status);
        },
        showButtonBoQuaBuocTest() {
            return this.is_lastest_version
                && [STATUS_REGISTERED, STATUS_ABSENT, STATUS_CHEAT].includes(this.exam.status);
        },
        showButtonDangKyThiLai() {
            return this.is_lastest_version && ['Gian lận', 'Vắng thi'].includes(this.exam.status);
        },
        resultTests() {
            // Có skill + score != null thì hiện (score = 0 vẫn hiện)
            return SKILLS
                .map((skill) => this.makeResult(skill))
                .filter((result) => result !== null);
        },
        hasResultContent() {
            return this.resultTests.length > 0 || this.hasOverallScore;
        },
        overallScore() {
            return this.formatScore(this.exam.avg_score);
        },
        // avg_score != null mới hiện Overall / khóa học gợi ý
        hasOverallScore() {
            return this.exam.avg_score !== null && this.exam.avg_score !== undefined;
        },
        examWebUrl() {
            const baseUrl = this.exam.center_id === ECOACH
                ? process.env.VUE_APP_TEST_ENTRACNE_ECOACH
                : process.env.VUE_APP_TEST_ENTRACNE;
            return baseUrl + 'login-entrance?token=' + this.exam.uuid;
        },
        statusText() {
            return this.exam.status || "";
        },
        statusClass() {
            switch (this.exam.status) {
                case STATUS_RETURNED_RESULT:
                    return "badge-success";
                case STATUS_CHEAT:
                    return "badge-danger";
                case STATUS_ABSENT:
                    return "badge-warning";
                case STATUS_DA_BO_QUA_KIEM_TRA_LABEL:
                    return "badge-secondary";
                case STATUS_REGISTERED:
                default:
                    return "badge-primary";
            }
        }
    },
    methods: {
        openSkipDialog() {
            this.checkStatus(TYPE_CHECK_BO_QUA).then((canOpen) => {
                if (canOpen) {
                    this.skipDialogVisible = true;
                }
            });
        },
        handleSkipped() {
            this.$set(this.exam, 'status', STATUS_DA_BO_QUA_KIEM_TRA_LABEL);
        },
        async getEntranceExamResult() {
            if (!this.markingExamRetakeId) {
                this.$message.error("Có lỗi xảy ra, vui lòng thử lại");
                return;
            }
            this.loading = true;
            try {
                const res = await this.$store.dispatch(GET_RESULT_ENTRANCE_EXAM, {
                    marking_exam_retake_id: this.markingExamRetakeId
                });
                if (res && !res.error) {
                    this.exam = res.data || {};
                    return;
                }
                this.$message.error(res?.message || "Không lấy được chi tiết ca thi đầu khóa");
            } catch (error) {
                this.$message.error(error?.data?.message || "Không lấy được chi tiết ca thi đầu khóa");
            } finally {
                this.loading = false;
            }
        },
        openEntranceScheduleDialog(isRetake) {
            const type = isRetake ? TYPE_CHECK_DANG_KY_THI_LAI : TYPE_CHECK_DAT_LAI;
            this.checkStatus(type).then((canOpen) => {
                if (!canOpen) {
                    return;
                }
                this.entranceRetakeMode = isRetake;
                this.scheduleEntranceTestDialogVisible = true;
            });
        },
        async confirmEntranceSchedule(payload = {}) {
            this.entranceScheduleConfirmLoading = true;
            try {
                const type = this.entranceRetakeMode
                    ? TYPE_CHECK_DANG_KY_THI_LAI
                    : TYPE_CHECK_DAT_LAI;
                const canProceed = await this.checkStatus(type);
                if (!canProceed) {
                    return;
                }
                if (payload.type === 'basic') {
                    await this.createSpeakingAiEntranceSchedule(payload.center_id);
                    return;
                }
                if (payload.type === 'higher') {
                    await this.registerEntranceExamSchedule(payload);
                    return;
                }
                if (payload.type === 'mastery') {
                    await this.createMasteryEntranceSchedule(payload);
                }
            } finally {
                this.entranceScheduleConfirmLoading = false;
            }
        },
        checkStatus(type) {
            const id = this.markingExamRetakeId;
            if (!id) {
                this.$message.error('Không tìm thấy thông tin ca thi đầu khóa');
                return Promise.resolve(false);
            }
            return this.$store.dispatch(CHECK_STATUS_ENTRANCE_EXAM, { id, type }).then(() => {
                return true;
            }).catch((error) => {
                this.getEntranceExamResult();
                this.closeEntranceScheduleDialog();
                if (error && error.data) {
                    this.$message.error(error.data.message);
                }
                return false;
            });
        },
        closeEntranceScheduleDialog() {
            this.scheduleEntranceTestDialogVisible = false;
            this.entranceScheduleConfirmLoading = false;
        },
        // Basic: đặt lịch test speaking với AI
        createSpeakingAiEntranceSchedule(centerId) {
            if (!this.customerId) {
                this.$message({
                    type: 'warning',
                    message: 'Không tìm thấy thông tin khách hàng để đặt lịch. Vui lòng thử lại.',
                    showClose: true
                });
                return Promise.resolve();
            }
            const payload = {
                name: this.exam.user_name,
                phone: this.exam.user_phone,
                customer_id: this.customerId,
                center_id: centerId
            };
            this.statusCreateTestInput = TYPE_SPEAKING_AI;
            return this.$store.dispatch(STORE_SPEAKING_API, payload).then((data) => {
                if (!data.data) {
                    this.$message({
                        message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
                        type: 'warning'
                    });
                    return;
                }
                const testInputScheduleId = data?.data?.id;
                if (!testInputScheduleId || data?.error) {
                    return;
                }
                this.$message({
                    type: 'success',
                    message: 'Đặt lịch thành công',
                    showClose: true
                });
                this.closeEntranceScheduleDialog();
                this.$router.push({
                    name: 'customer-test-input-entrance',
                    params: { id: testInputScheduleId },
                    query: {
                        status: this.statusCreateTestInput,
                        customer_id: this.customerId,
                        is_latest: '1'
                    }
                });
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đặt lịch Speaking AI thất bại',
                    showClose: true
                });
            });
        },
        // Cao hơn Basic: đăng ký lại ca thi đầu khóa
        registerEntranceExamSchedule({ center_id, marking_exam_shift_id }) {
            if (!this.exam.user_id) {
                this.$message({
                    type: 'warning',
                    message: 'Không tìm thấy thông tin học viên để đăng ký lịch thi. Vui lòng thử lại.',
                    showClose: true
                });
                return Promise.resolve();
            }
            return this.$store.dispatch(REGISTER_ENTRANCE_EXAM, {
                user_id: this.exam.user_id,
                center_id: center_id,
                marking_exam_shift_id: Number(marking_exam_shift_id)
            }).then((res) => {
                this.$message({
                    type: res?.error ? 'warning' : 'success',
                    message: res?.message || 'Đăng ký lịch thi đầu khóa thành công',
                    showClose: true
                });
                if (res?.error) {
                    return;
                }
                this.closeEntranceScheduleDialog();
                const retakeId = res?.data?.id;
                if (!retakeId || String(retakeId) === String(this.markingExamRetakeId)) {
                    this.getEntranceExamResult();
                    return;
                }
                const query = { is_latest: '1' };
                if (this.customerId) query.customer_id = this.customerId;
                this.$router.replace({
                    name: 'customer-entrance-exam-schedule',
                    params: { marking_exam_retake_id: retakeId },
                    query
                });
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đăng ký lịch thi đầu khóa thất bại',
                    showClose: true
                });
            });
        },
        // Mentor English Mastery: đặt lịch test với admin test
        createMasteryEntranceSchedule({ testInput }) {
            if (!this.customerId) {
                this.$message({
                    type: 'warning',
                    message: 'Không tìm thấy thông tin khách hàng để đặt lịch. Vui lòng thử lại.',
                    showClose: true
                });
                return Promise.resolve();
            }
            const payload = buildScheduleBandPayload({
                payload: { ...testInput, customer_id: this.customerId },
                bandType: 1,
                masteryCenterId: Mentor_English_Mastery_ID
            });
            return this.$store.dispatch(CREATE_TEST_INPUT_SCHEDULE_CUSTOMER, payload).then((data) => {
                this.$message({
                    type: 'success',
                    message: 'Đặt lịch thành công',
                    showClose: true
                });
                this.closeEntranceScheduleDialog();
                this.idCustomer = this.customerId;
                this.idTaskCreating = data?.data?.id;
                this.createdTestInputScheduleId = data?.data?.test_input_schedule_id;
                this.statusCreateTestInput = STATUS_PENDING;
                this.openScheduleTestInput = true;
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đặt lịch test đầu vào thất bại',
                    showClose: true
                });
            });
        },
        handleStatusCreateTestInput(status, customerId, dataResponse) {
            this.idCustomer = customerId;
            this.successCreateData = dataResponse;

            if (+status === STATUS_TO_DO) {
                const scheduleId = this.createdTestInputScheduleId
                    || dataResponse?.test_input_schedule_id
                    || dataResponse?.test_input_schedule?.id;
                const query = { is_latest: '1' };
                const customerIdQuery = this.customerId || customerId;
                if (customerIdQuery) query.customer_id = customerIdQuery;

                this.openScheduleTestInput = false;
                this.statusCreateTestInput = null;
                this.idTaskCreating = null;
                this.createdTestInputScheduleId = null;

                this.$message({
                    type: 'success',
                    message: 'Đặt lịch thành công',
                    showClose: true
                });

                if (scheduleId) {
                    this.$router.replace({
                        name: 'customer-test-input-entrance',
                        params: { id: scheduleId },
                        query
                    });
                    return;
                }
                this.getEntranceExamResult();
                return;
            }

            setTimeout(() => {
                this.statusCreateTestInput = status;
            });
        },
        resetModal() {
            this.statusCreateTestInput = null;
            this.idTaskCreating = null;
            this.createdTestInputScheduleId = null;
            this.countTime = 60;
        },
        makeResult(skill) {
            const data = this.exam[skill.key];
            if (!data) {
                return null;
            }
            // Chưa chấm (score null) → không hiện card
            if (data.score === null || data.score === undefined || data.score === "") {
                return null;
            }
            return {
                key: skill.key,
                name: skill.name,
                score: this.formatScore(data.score),
                correctCount: data.correct_count || 0,
                totalQuestions: data.total_questions || 0,
                comments: this.extractComments(data.score_data)
            };
        },
        extractComments(scoreData) {
            const teacherMarks = Array.isArray(scoreData)
                ? scoreData.flatMap((item) => item?.teacher_marks || [])
                : scoreData?.teacher_marks || [];

            return teacherMarks.map((mark) => ({
                name: mark.label_parent || mark.label || mark.key_parent || mark.key || "",
                autoComment: this.normalizeComment(mark.comment_auto),
                detail: this.normalizeComment(mark.comment_detail),
                score: mark.score
            }));
        },
        formatScore(score) {
            if (score === null || score === undefined || score === "") {
                return "0.0";
            }
            return Number(score).toFixed(1);
        },
        formatDate(value) {
            if (!value) {
                return "";
            }
            return moment(value).format("DD/MM/YYYY");
        },
        formatTime(value) {
            if (!value) {
                return "";
            }
            return moment(value, "HH:mm:ss").format("HH:mm:ss");
        },
        normalizeComment(value) {
            return (value || "").replace(/<br\s*\/?>/gi, "\n");
        },
        copyText(value) {
            if (!this.is_lastest_version) return;
            if (!value) {
                this.$message.warning("Không có nội dung để sao chép");
                return;
            }
            navigator.clipboard.writeText(value);
            this.$message.success("Sao chép thành công");
        }
    }
};
</script>

<style scoped>
.exam-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
}

.content_result {
    max-height: 750px;
    overflow-y: auto;
    height: fit-content;
}

.status-test-input {
    font-size: 14px;
}

.exam-guide__title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 6px;
}

.exam-guide__desc {
    color: #7e8299;
    font-size: 13px;
    margin-bottom: 12px;
}

.exam-guide__label {
    color: #7e8299;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;
    margin-bottom: 4px;
}

.exam-guide__qr {
    border: 1px solid #e4e6ef;
    border-radius: 6px;
    padding: 6px;
    line-height: 0;
}

.exam-guide__copy {
    cursor: pointer;
    font-size: 15px;
    line-height: 40px;
}

.exam-guide__copy:hover {
    color: #0066ff;
}

.exam-guide__field >>> .el-input__inner {
    background-color: #ffffff;
    border-color: #e4e6ef;
    color: #3f4254;
}

.exam-guide__field--link >>> .el-input__inner {
    color: #0066ff;
}
</style>
